module.exports = __webpack_public_path__ + "img/Banner_Home_4.7ddc3ee9.png";